import React, {useEffect, useState} from 'react'
import Utils from "@/utils/Default/Utils";

const LoadingProgressiveResource = (props) => {

    const [userLevel, setUserLevel] = useState('');

    useEffect(() => {
        let userLevelCookie = Utils.getCookieValue('user-level')
        if (userLevelCookie && ['1', '2', '3'].includes(userLevelCookie)) {
            setUserLevel('Level' + userLevelCookie)
        } else {
            setUserLevel('Level3')
        }
    }, [])
    const {children, resourceName, resources} = props
    if (userLevel != '' && resources && (resources[resourceName]?.enabledLevels.includes(userLevel) || typeof resources[resourceName] === "undefined")) {
        return (
            <>
                {children}
            </>
        )
    }
    return null;

}
export default LoadingProgressiveResource